import { useMutation } from "@tanstack/react-query"
import axios from "axios"

export const useDownloadCustomersTemplateMutation = () => {
  return useMutation({
    mutationFn: async () => {
      const response = await axios.get("/importers/customers", {
        responseType: "blob",
      })

      const blob = response.data
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = url
      a.download = "customers.xlsx"
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
  })
}
